import { create } from 'zustand';
import type { RoomInvitePayload } from '@shared/protocol';

interface InvitesState {
  invites: RoomInvitePayload[];
  setAll: (list: RoomInvitePayload[]) => void;
  add: (inv: RoomInvitePayload) => void;
  remove: (code: string) => void;
  clear: () => void;
}

export const useInvites = create<InvitesState>((set) => ({
  invites: [],
  setAll: (list) => set({ invites: dedup(list) }),
  add: (inv) =>
    set((s) => ({
      invites: dedup([inv, ...s.invites.filter((x) => x.code !== inv.code)]),
    })),
  remove: (code) => set((s) => ({ invites: s.invites.filter((x) => x.code !== code) })),
  clear: () => set({ invites: [] }),
}));

function dedup(list: RoomInvitePayload[]): RoomInvitePayload[] {
  const now = Date.now();
  const seen = new Set<string>();
  return list.filter((i) => {
    if (i.expiresAt <= now) return false;
    if (seen.has(i.code)) return false;
    seen.add(i.code);
    return true;
  });
}
